'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$resource',
    function ($resource) {
        return $resource('api/countries/:countryId', null, {
            getAll: {method: 'GET'},
            get: {method: 'GET'},
            create: {method: 'POST'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            enable: {url: 'api/countries/:countryId/enable', method: 'PUT'},
            delete: {url: 'api/countries/:countryId/delete', method: 'PUT'},
            getDefault: {url: 'api/countries/default', method: 'GET'},
            setDefault: {url: 'api/countries/:countryId/default', method: 'PUT'},
            isUniqueName: {url: 'api/countries/unique/name/:name', method: 'GET'}
        });
    }];